import React from 'react';
import {AlertDialog, Box} from 'native-base';
import {PrimaryButton, SecondaryButton} from '../buttons';
import {message} from '../../utils/messages';

export const useGeolocationAlert = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [permissionState, setPermissionState] = React.useState({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onClose: (result: boolean) => {},
  });

  const showGeolocationAlert = () => {
    setIsOpen(true);
  };

  const onClose = (result: boolean) => {
    permissionState.onClose(result);
  };

  const requestPermission = async (): Promise<boolean> => {
    showGeolocationAlert();

    // Wait for the user to close the alert using a promise
    const result: Promise<boolean> = new Promise(resolve => {
      setPermissionState({
        // eslint-disable-next-line @typescript-eslint/no-shadow
        onClose: (result: boolean) => {
          resolve(result); // Resolve with true if 'YES' is pressed, false otherwise
          setIsOpen(false); // Close the alert after resolving the promise
        },
      });
    });
    return result;
  };

  const GeolocationAlert = () => {
    const cancelRef = React.useRef(null);
    return (
      <AlertDialog leastDestructiveRef={cancelRef} isOpen={isOpen}>
        <AlertDialog.Content>
          <AlertDialog.Header>
            {message('geolocation-disclousure-title')}
          </AlertDialog.Header>
          <AlertDialog.Body>
            {message('geolocation-disclousure-content')}
          </AlertDialog.Body>
          <AlertDialog.Footer
            alignContent={'space-between'}
            justifyContent={'space-between'}
            flexDirection={'row'}>
            <Box width={'40%'}>
              <SecondaryButton onPress={() => onClose(false)} label="No" />
            </Box>
            <Box width={'40%'}>
              <PrimaryButton onPress={() => onClose(true)} label="Sí" />
            </Box>
          </AlertDialog.Footer>
        </AlertDialog.Content>
      </AlertDialog>
    );
  };

  return {GeolocationAlert, showGeolocationAlert, requestPermission};
};
